export default __webpack_public_path__ + "static/media/banner-05.cf18c364.jpg";